const BorrowerStepper = ({ steps, activeStep }) => {
  return (
    <>
      <p className="text-[#000000] mb-[15px] text-[15px] font-bold">
        Borrower Registration Progress
      </p>
      <div className="flex flex-col">
        {steps.map((step, index) => {
          const isActive = index === activeStep;
          const isLastStep = index === steps.length - 1;

          return (
            <div
              key={index}
              className="flex items-start gap-4 cursor-pointer relative"
            >
              {/* Step icon and connector */}
              <div className="flex flex-col items-center">
                {/* Circle */}
                <div
                  className={`w-4 h-4 rounded-full ${
                    isActive
                      ? "bg-[#000000] border-[2px] bg-white border-[#000000]"
                      : "border-[2px] border-[#A8A8A8] bg-white"
                  }`}
                />

                {/* Vertical line (connector) */}
                {!isLastStep && (
                  <div className="w-px h-[35px] bg-gray-300"></div>
                )}
              </div>

              {/* Step content */}
              <div className="h-[51px]">
                <p
                  className={`text-[14px] leading-[1.1] font-medium ${
                    isActive ? "text-[#000000]" : "text-[#5C5C5C]"
                  }`}
                >
                  {step.title}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default BorrowerStepper;
